import windowManager from "_src/client/window_manager";
import renderGraphManager from "_src/render_graph/render_graph";
import events from "_src/engine/events";
import memoryProfiler from "_src/engine/memory_profiler";

let element = null;
let parent = null;
let enabled = false;

let passUsageInfo = null;

export default {

  init(container) {

    createElement();

    parent = container;

    events.on("memory_report", (params) => {

      passUsageInfo = params.passes;

      this.update();

    });

  },

  enable() {
    if (enabled) {
      return;
    }
    parent.appendChild(element);
    enabled = true;
  },

  disable() {
    if (!enabled) {
      return;
    }
    parent.removeChild(element);
    enabled = false;
  },

  update() {

    if (enabled) {

      let degubInfo = "";

      const renderGraphs = passUsageInfo.renderGraphs;

      const renderingInfo = getRenderingInfo();

      for (let i = 0; i < renderGraphs.length; i++) {

        degubInfo += "<table border='1' style='width: 100%; border-collapse: collapse;' bordercolor='black'>";

        degubInfo += "<caption>" + "RenderGraph" + i + "</caption>";

        const renderGraphInfo = renderGraphs[i];
        const renderGraphStat = renderingInfo[i];

        degubInfo += "<tr>";
        degubInfo += "<th></th>";
        for (let passName in renderGraphInfo) {

          for (let option in renderGraphInfo[passName]) {
            degubInfo += "<th><span style='color: green;'>" + option + "</span></th>";
          }

          if (renderGraphStat) {
            for (let option in renderGraphStat[passName]) {
              degubInfo += "<th><span style='color: green;'>" + option + "</span></th>";
            }
          }

          break;

        }
        degubInfo += "</tr>";

        for (let passName in renderGraphInfo) {

          degubInfo += "<tr>";
          degubInfo += "<th><span style='color: green;'>" + passName + "</span></th>";

          for (let option in renderGraphInfo[passName]) {
            const data = renderGraphInfo[passName][option];
            degubInfo += "<th>" + data.count + " (" + data.memory + ")" + "</th>";
          }

          if (renderGraphStat) {
            for (let option in renderGraphStat[passName]) {
              const passStat = renderGraphStat[passName];
              if (passStat) {
                degubInfo += "<th>" + passStat[option] + "</th>";
              } else {
                degubInfo += "<th>-</th>";
              }
            }
          }

          degubInfo += "</tr>";

        }

        degubInfo += "</table>";

      }

      degubInfo += "<table border='1' style='border-collapse: collapse;' bordercolor='black'>";
      degubInfo += "<caption>" + "Total info" + "</caption>";

      degubInfo += "<tr>";
      degubInfo += "<th></th>";
      if ("gpu" in passUsageInfo.total) {
        degubInfo += "<th><span style='color: green;'>GPU</span>" + "</th>";
      }
      if ("cpu" in passUsageInfo.total) {
        degubInfo += "<th><span style='color: green;'>CPU</span>" + "</th>";
      }
      degubInfo += "</tr>";

      degubInfo += "<tr>";
      degubInfo += "<th>Geometry</th>"
      degubInfo += "<th>" + passUsageInfo.total.gpu.geometry.count + "(" + memoryProfiler.getReadableMemoryStr(passUsageInfo.total.gpu.geometry.size) + ")" + "</th>";
      degubInfo += "<th>" + passUsageInfo.total.cpu.geometry.count + "(" + memoryProfiler.getReadableMemoryStr(passUsageInfo.total.cpu.geometry.size) + ")" + "</th>";
      degubInfo += "</tr>";

      degubInfo += "<tr>";
      degubInfo += "<th>Textures</th>"
      degubInfo += "<th>" + passUsageInfo.total.gpu.textures.count + "(" + memoryProfiler.getReadableMemoryStr(passUsageInfo.total.gpu.textures.size) + ")" + "</th>"
      degubInfo += "<th>-</th>"
      degubInfo += "</tr>";

      degubInfo += "<tr>";
      degubInfo += "<th>Fbo</th>"
      degubInfo += "<th>" + passUsageInfo.total.gpu.fbo.count + "(" + memoryProfiler.getReadableMemoryStr(passUsageInfo.total.gpu.fbo.size) + ")" + "</th>"
      degubInfo += "<th>-</th>"
      degubInfo += "</tr>";

      degubInfo += "</table>";

      element.innerHTML = degubInfo.replace(/\t/g, "&emsp;", "g").split("\n").join("\n" + "<br />");

    }

  },

  cleanup() {
    parent = null;
    element = null;
  }

}

function createElement() {
  element = document.createElement("div");
  setElementStyle();
}

function getRenderingInfo() {

  const renderingInfo = [];

  const mainWindow = windowManager.getWindow(windowManager.MAIN);
  if (mainWindow) {
    renderingInfo.push(getWindowInfo(mainWindow));
  }

  const aligneeWindow = windowManager.getWindow(windowManager.ALIGNEE);
  if (aligneeWindow) {
    renderingInfo.push(getWindowInfo(aligneeWindow));
  }

  const alignerWindow = windowManager.getWindow(windowManager.ALIGNER);
  if (alignerWindow) {
    renderingInfo.push(getWindowInfo(alignerWindow));
  }

  return renderingInfo;

}

function getWindowInfo(window) {

  const renderGraph = window.renderGraph;

  let windowInfo = {};

  const nodes = renderGraph.getNodes();
  for (let i = 0; i < nodes.length; ++i) {
    windowInfo[renderGraphManager.getPassName(i)] = getPassInfo(nodes[i]);
  }

  return windowInfo;

}

function setElementStyle() {

  element.style.position = "absolute";
  element.style.width = "100%";
  element.style.height = "100%";
  element.style.left = 0;
  element.style.top = 0;

  element.style.backgroundColor = "rgba(0,0,0,0.3)";
  element.style.color = "white";
  element.style.alignItems = "center";
  element.style.justifyContent = "center";
  element.style.display = "flex";
  element.style.font = "bold 10px Courier";
  element.style.lineHeight = "1.0";
  element.style.scrollable = "true";
  element.style.flexDirection = "column";

  element.style.zIndex = 2;
  element.style.pointerEvents = "none";

}

function getPassInfo(pass) {

  const scenes = pass.getScenes();

  let totalChunksCount = 0;
  let hiddenChunksCount = 0;
  let inFrustunChunksCount = 0;
  let queryTestFailedChunksCount = 0;

  for (let scene of scenes) {

    const objects = [scene];

    while (objects.length) {

      const object = objects.pop();

      const children = object.getChildren();

      if (children.length) {
        objects.push.apply(objects, children);
      }

      if (object.isDrawable) {

        totalChunksCount += object.chunks.length;

        if (object.checkIsHidden()) {
          hiddenChunksCount += object.chunks.length;
          continue;
        }

        for (let chunk of object.chunks) {

          if (!chunk.hasDrawElements() && chunk.isEmpty()) {
            continue;
          }

          const inFrustum = object.isChunkInFrustum(chunk);
          const queryResult = object.getChunkQueryResult(chunk);

          if (!queryResult) {
            queryTestFailedChunksCount++;
            continue;
          }

          if (!inFrustum) {
            inFrustunChunksCount++;
            continue;
          }

        }

      }

    }

  }

  let result = {};

  result["Scenes count"] = scenes.length;
  result["Chunks"] = totalChunksCount;
  result["Hidden"] = hiddenChunksCount;
  result["Querry test (failed)"] = queryTestFailedChunksCount;
  result["Frustum test (failed)"] = inFrustunChunksCount;

  return result;

}